"use client";

import { useEffect } from "react";
import clarity from "@microsoft/clarity";
import { NEXT_PUBLIC_REACT_APP_DOMAIN } from "@/common";
import { BaseAppChannel } from "@/utils/base-app-channel";
import { buildClientInfo } from "@/utils/deviceInfo";

export default function ClarityAnalytics() {
  // 异步获取并上报用户信息
  const setupUserTracking = async () => {
    try {
      // 获取用户信息
      const userInfo = await BaseAppChannel.getUserInfoAsync();
      const clientInfo = await buildClientInfo();

      if ("device_id" in clientInfo && clientInfo.device_id) {
        clarity.identify(clientInfo.device_id);
      }

      // 上报自定义标签
      if (userInfo?.uid) {
        clarity.setTag("uid", userInfo.uid);
      }

      if (userInfo?.creator_unique_id) {
        clarity.setTag("creator_unique_id", userInfo.creator_unique_id);
      }
      if ("device_id" in clientInfo && clientInfo.device_id) {
        clarity.setTag("device_id", clientInfo.device_id);
      }
      if (clientInfo?.client_version) {
        clarity.setTag("client_version", clientInfo.client_version);
      }
    } catch {}
  };
  useEffect(() => {
    // 仅在生产环境初始化 Clarity
    if (NEXT_PUBLIC_REACT_APP_DOMAIN !== "online") {
      return;
    }

    // 初始化 Clarity
    clarity.init("jdb91ny9me");

    setupUserTracking();
  }, []);

  return null;
}
